import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem('aafti_cart');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('aafti_cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product, quantity = 1) => {
    setCartItems(prev => {
      const incomingQty = Math.max(1, Number(quantity || 1));
      const hasTrackedStock = product?.delivery_type === 'stock' && product?.stock_quantity !== null && product?.stock_quantity !== undefined && product?.stock_quantity !== '';
      const stockLimit = hasTrackedStock ? Math.max(0, Number(product.stock_quantity)) : null;

      if (hasTrackedStock && stockLimit === 0) {
        return prev;
      }

      const existing = prev.find(item => item.id === product.id);
      if (existing) {
        const nextQtyRaw = item => item.quantity + incomingQty;
        return prev.map(item => 
          item.id === product.id 
            ? { ...item, quantity: hasTrackedStock && stockLimit !== null ? Math.min(stockLimit, nextQtyRaw(item)) : nextQtyRaw(item) } 
            : item
        );
      }
      const initialQty = hasTrackedStock && stockLimit !== null ? Math.min(stockLimit, incomingQty) : incomingQty;
      return [...prev, { ...product, quantity: initialQty }];
    });
  };

  const removeFromCart = (productId) => {
    setCartItems(prev => prev.filter(item => item.id !== productId));
  };

  const updateQuantity = (productId, quantity) => {
    if (quantity <= 0) {
      removeFromCart(productId);
      return;
    }
    setCartItems(prev => 
      prev.map(item => {
        if (item.id !== productId) return item;
        const hasTrackedStock = item?.delivery_type === 'stock' && item?.stock_quantity !== null && item?.stock_quantity !== undefined && item?.stock_quantity !== '';
        const stockLimit = hasTrackedStock ? Math.max(0, Number(item.stock_quantity)) : null;
        const nextQty = hasTrackedStock && stockLimit !== null ? Math.min(stockLimit, quantity) : quantity;
        return { ...item, quantity: Math.max(1, nextQty) };
      })
    );
  };

  const clearCart = () => setCartItems([]);

  const cartTotal = cartItems.reduce((sum, item) => {
    const price = parseFloat(item.price || item.b2c_price || 0);
    return sum + (price * item.quantity);
  }, 0);

  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, updateQuantity, clearCart, cartTotal, cartCount }}>
      {children}
    </CartContext.Provider>
  );
};
